import React from 'react';

/**
 * TabStrip — reusable horizontal tab buttons.
 *
 * @param {Array<{id: string, icon: string, label: string}>} tabs
 * @param {string} active — currently selected tab id
 * @param {(id: string) => void} onChange
 */
export default function TabStrip({ tabs, active, onChange }) {
  return (
    <div
      className="grid gap-2 mb-3"
      style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }}
    >
      {tabs.map(t => (
        <button
          key={t.id}
          type="button"
          onClick={() => onChange(t.id)}
          className={`tab-pill ${active === t.id ? 'active' : ''}`}
          style={{ width: '100%', textAlign: 'center' }}
        >
          <span className="mr-1" aria-hidden="true">{t.icon}</span>
          {t.label}
        </button>
      ))}
    </div>
  );
}
